var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-column"},[_c('Header'),_vm._v(" "),_c('RankContent'),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('BackTop')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c99951a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/layout/Rank.vue
// module id = null
// module chunks = 